import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/content';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-shell py-20 md:py-28" aria-labelledby="faq" data-id="element-66" data-mp="1gketo30eyvlt">
      <div className="mx-auto max-w-3xl px-6 lg:px-8" data-id="element-67" data-mp="24a91u79sfvzq">
        <SectionHeading eyebrow="Preguntas" title={<span id="faq" data-id="element-69" data-mp="289q8h40yaz6h">Preguntas frecuentes</span>} data-id="element-68" data-mp="24bk76bivtbsy" />

        <div className="mt-14 divide-y divide-sand border-y border-sand" data-id="element-70" data-mp="28cm60r8vzlue">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <Reveal key={faq.question} delay={i * 0.05} data-id="element-71" data-mp="1zh6i0qutc0wq" data-mpi={i}>
                <h3 data-id="element-72" data-mp="2n8bwp2p0on5g">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-6 py-6 text-left transition-colors duration-300 hover:text-gold" data-id="element-73" data-mp="2n7scffbw9mo9">
                    <span className="font-display text-xl font-light text-ink sm:text-2xl" data-id="element-74" data-mp="14sxsbg78men7">
                      {faq.question}
                    </span>
                    <motion.span animate={{
                  rotate: isOpen ? 45 : 0
                }} transition={{
                  duration: 0.35,
                  ease: [0.16, 1, 0.3, 1]
                }} className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-beige text-gold" aria-hidden="true" data-id="element-75" data-mp="1elvfw0r36tso">
                      <PlusIcon className="h-3.5 w-3.5" data-id="element-76" data-mp="1jmj4kfrueyjq" />
                    </motion.span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-77" data-mp="1skmr9feke1d4">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.45,
                ease: [0.16, 1, 0.3, 1]
              }} className="overflow-hidden" data-id="element-78" data-mp="1sj1ztynjqyjh">
                      <p className="max-w-reading pb-7 font-sans text-[0.97rem] font-light leading-[1.9] text-warmgray" data-id="element-79" data-mp="28715h33hst2f">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}